import { Col, Form, Input, Row } from "antd"
import React from "react"
import Banners from "./Banners"

interface Props {
    cdnUrl: string
    preSignUrl: string
    type: string
    basePath?: any
    restFields?: any
}

const IntentGenerationBanner: React.FC<Props> = ({ cdnUrl, preSignUrl, type, basePath, restFields }) => {
    return (
        <>
            <Row gutter={16} style={{ width: '100%', marginBottom: 8 }}>
                {/* Title and Description in one row */}
                <Col span={12}>
                    <Form.Item
                        {...restFields}
                        label="Title"
                        name={[...basePath, 'intent_generation_banner', 'title']}
                        labelCol={{ span: 24 }}
                        wrapperCol={{ span: 24 }}
                        rules={[{ required: false, message: 'Enter Title' }]}
                    >
                        <Input placeholder="Enter Title" />
                    </Form.Item>
                </Col>
                <Col span={12}>
                    <Form.Item
                        {...restFields}
                        label="Description"
                        name={[...basePath, 'intent_generation_banner', 'description']}
                        labelCol={{ span: 24 }}
                        wrapperCol={{ span: 24 }}
                        rules={[{ required: false, message: 'Enter Description' }]}
                    >
                        <Input placeholder="Enter Description" />
                    </Form.Item>
                </Col>
            </Row>

            <Row gutter={16} style={{ width: '100%' }}>
                {/* BG Color 1 and BG Color 2 in one row */}
                <Col span={12}>
                    <Form.Item
                        label="BG Color 1"
                        name={[...basePath, 'intent_generation_banner', 'bg_hex_code_1']}
                        labelCol={{ span: 24 }}
                        wrapperCol={{ span: 24 }}
                        rules={[
                            { required: false, message: 'Enter Bg color 1' },
                            {
                                pattern: /^#[A-Fa-f0-9]{6}$/,
                                message: 'Please enter a valid hex color code starting with # (e.g., #ffffff)'
                            }
                        ]}
                    >
                        <Input placeholder="Enter hex color code (e.g., #ffffff)" />
                    </Form.Item>
                </Col>
                <Col span={12}>
                    <Form.Item
                        label="BG Color 2"
                        name={[...basePath, 'intent_generation_banner', 'bg_hex_code_2']}
                        labelCol={{ span: 24 }}
                        wrapperCol={{ span: 24 }}
                        rules={[
                            { required: false, message: 'Enter bg color 2' },
                            {
                                pattern: /^#[A-Fa-f0-9]{6}$/,
                                message: 'Please enter a valid hex color code starting with # (e.g., #ffffff)'
                            }
                        ]}
                    >
                        <Input placeholder="Enter hex color code (e.g., #000000)" />
                    </Form.Item>
                </Col>
            </Row>


            <Form.List name={[...basePath, 'intent_generation_banner', 'stores_list']}>
                {(fields, { add, remove, move }) => (
                    <>
                        <Row justify="space-between" style={{ width: '100%' }}>
                            <Banners
                                onSortEnd={({ oldIndex, newIndex }) => {
                                    console.log('oldIndex', oldIndex, 'newIndex', newIndex)
                                    move(oldIndex, newIndex)
                                }}
                                distance={1}
                                helperClass='sortableHelper'
                                fields={fields}
                                add={add}
                                remove={remove}
                                cdnUrl={cdnUrl}
                                preSignUrl={preSignUrl}
                                datatype='Intent Generation Banner'
                            />
                        </Row>
                    </>
                )}
            </Form.List>
        </>
    )
}

export default IntentGenerationBanner